import { ResendVerifyEmailButton } from '../../components';
import { useUserInfo } from './useUserInfoData';

export const UserDashboard = () => {
  const { userInfo } = useUserInfo();

  if (!userInfo) {
    return 'no user found';
  }

  return (
    <div>
      <p>UserDashboard: {userInfo.email}</p>
      {!userInfo.emailVerified && <ResendVerifyEmailButton />}
    </div>
  );
};
